import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = ["href"]
const _hoisted_2 = { class: "gfu-bt gfu-bt--caption _tc--light _mb-1" }
const _hoisted_3 = { class: "_mt-a _flex _jc-fe _gap-2" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_button = _resolveComponent("base-button")
  const _component_push_notification_list_item = _resolveComponent("push-notification-list-item")

  return (_openBlock(), _createElementBlock("a", {
    class: "gfu-link--nofx _h-full _grid",
    href: $props.urlAction
  }, [
    _createVNode(_component_push_notification_list_item, {
      "image-url": $props.actionImage,
      "data-qa": `pending-action:${$props.userPendingActionID}`
    }, {
      "message-title": _withCtx(() => [
        _createElementVNode("span", null, _toDisplayString($options.actionText), 1 /* TEXT */)
      ]),
      "message-text": _withCtx(() => [
        _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.Resources.Layout.InLabel) + " " + _toDisplayString($props.projectName), 1 /* TEXT */)
      ]),
      actions: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          ($props.canDismiss)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "_tc--accent",
                onClick: _cache[0] || (_cache[0] = _withModifiers((...args) => ($options.onDismissClick && $options.onDismissClick(...args)), ["prevent"])),
                "data-qa": "action-dismiss"
              }, _toDisplayString(_ctx.Resources.Layout.DismissActionButtonText), 1 /* TEXT */))
            : _createCommentVNode("v-if", true),
          _createVNode(_component_base_button, {
            theme: "accent",
            class: "_ttl",
            size: "micro",
            tag: "a",
            href: $props.urlAction,
            "data-qa": `call-to-action:${$options.actionKey}`
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString($options.actionLabel), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["href", "data-qa"])
        ])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["image-url", "data-qa"])
  ], 8 /* PROPS */, _hoisted_1))
}